import Site from "@/models/Site";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";
import { useMissionStore } from "./mission";
import { siteApi } from "@/api/projectClient";
import { validate as isUuid } from "uuid";

const SiteRepo = useRepo(Site);

export const useSiteStore = defineStore("site", {
  state: () => ({}),

  actions: {
    async fetchCurrentSiteWithImmediateDangers() {
      const missionStore = useMissionStore();
      const projectUuid = missionStore.currentMissionUuid;
      try {
        const response = await siteApi.withImmediateDangers({
          projectId: projectUuid,
        });
        if (response) {
          SiteRepo.save(response);
          return response;
        }
      } catch (error) {
        console.error(error);
        return null;
      }
    },

    async createOrUpdateCurrentSite(site) {
      const missionStore = useMissionStore();
      const mission = missionStore.currentMission;
      site.project = mission.uuid;

      let response;
      if (!site.uuid || !isUuid(site.uuid)) {
        response = await siteApi.create({ projectSiteRequest: site });
      } else {
        response = await siteApi.update({
          uuid: site.uuid,
          projectSiteRequest: site,
        });
      }

      return SiteRepo.save(response);
    },

    async partialUpdateCurrentSite(site) {
      const missionStore = useMissionStore();
      const mission = missionStore.currentMission;
      site.project = mission.uuid;

      const response = await siteApi.partialUpdate({
        uuid: site.uuid,
        patchedProjectSiteRequest: site,
      });

      if (response) {
        return SiteRepo.save(response);
      }
      return null;
    },
  },

  getters: {
    currentSite: () => {
      const missionStore = useMissionStore();
      return (
        SiteRepo.where("project", missionStore.currentMissionUuid).first() ||
        SiteRepo.make({ uuid: "" })
      );
    },
  },
});
